import * as React from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import EditEvent from "../../components/Forms/EditEvent";
import { UserAuth } from "../../context/AuthContext";
import { useParams } from "react-router-dom";
import { db } from "../../FirebaseConfig";
import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/joy/Link";
import Typography from "@mui/joy/Typography";
import Breadcrumbs from "@mui/joy/Breadcrumbs";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

interface RouteParams {
  [key: string]: string | undefined;
  id: string;
}

function parseSlug(slug: any): any {
  return slug
    .split("-")
    .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export default function EditEventPage() {
  const { userData } = UserAuth();
  const navigate = useNavigate();
  const { id } = useParams<RouteParams>();
  const [data, setData] = React.useState<any>({});
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (userData && !["admin", "super", "organizer"].includes(userData.role)) {
      navigate("/unauthorized", { replace: true });
    }
  }, [userData, navigate]);

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const eventData = await db
          .collection("Events")
          .doc(parseSlug(id).toLowerCase())
          .get();
        if (!eventData.exists) {
          setLoading(false);
        } else {
          setData(eventData.data());
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    };
    getData();
  }, [id]);

  if (!userData || !["admin", "super", "organizer"].includes(userData.role)) {
    return null;
  }

  return (
    <DashboardLayout
      navigator={
        <Breadcrumbs
          size="sm"
          aria-label="breadcrumbs"
          separator={<ChevronRightRoundedIcon fontSize="small" />}
          sx={{ pl: 0 }}
        >
          <Link
            underline="none"
            color="neutral"
            component={RouterLink}
            to="/manageevent"
            aria-label="Home"
          >
            <Typography fontWeight={500} fontSize={12}>
              Manage Event
            </Typography>
          </Link>
          <Link
            underline="none"
            color="neutral"
            component={RouterLink}
            to={`/manageevent/${id}`}
            aria-label="Home"
          >
            <Typography fontWeight={500} fontSize={12}>
              {parseSlug(id)}
            </Typography>
          </Link>
        </Breadcrumbs>
      }
      title={`Edit ${parseSlug(id)}`}
    >
      <EditEvent />
    </DashboardLayout>
  );
}
